import { render, staticRenderFns } from "./help-widget.vue?vue&type=template&id=d2695ac6&"
import script from "./help-widget.vue?vue&type=script&lang=js&"
export * from "./help-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports